import getPeople from '../../data_management/getPeople'

const QuestionnaireInstancesList = function ($scope, initialDataInteractor, personInteractor, emailInteractor, getReportInteractor, eventsService) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.coachees = getPeople(initialDataInteractor).map(person => person.id);
  };

  $ctrl.isCoachee = function (personId) {
    return $ctrl.coachees.includes(personId);
  };

  $ctrl.getStatusLabelFor = function (instance) {
    return instance.is_open ? 'open' : 'closed';
  };

  $ctrl.getReportUrlFor = function (instance) {
    return getReportInteractor.getReportUrlFor(instance);
  };

  $ctrl.getLabelFor = function (instance) {
    return instance.questionnaire;
  };

  $ctrl.includesPersonColumn = function () {
    if ($ctrl.questionnaireInstances) {
      let includes = false;

      $ctrl.questionnaireInstances.forEach(function (ri) {
        if (ri.person) {
          includes = true;
        }
      });

      return includes;
    }
  };

  $ctrl.includesQuestionnaireTitleColumn = function () {
    if ($ctrl.questionnaireInstances) {
      let includes = false;

      $ctrl.questionnaireInstances.forEach(function (ri) {
        if (ri.questionnaire) {
          includes = true;
        }
      });

      return includes;
    }
  };

  $ctrl.sendReminderEmail = function (questionnaireInstanceId) {
    emailInteractor.sendReminderEmailToPerson(questionnaireInstanceId, "This is a reminder to complete the below questionnaire")
      .then(
        () => eventsService.publishSystemMessage("The reminder email was sent successfully."),
        status => eventsService.publishSystemError("The reminder email failed to be sent. Error " + status)
      );
  };

  $ctrl.deleteQuestionnaireInstance = function (instance) {
    personInteractor.deleteQuestionnaireInstance(instance.identifier).then(() => {
      $ctrl.questionnaireInstances.splice($ctrl.questionnaireInstances.indexOf(instance), 1);
      $scope.$digest();
    });
  };
};

export default {
  name: 'questionnaireInstancesList',
  obj: {
    controller: QuestionnaireInstancesList,
    templateUrl: 'components/questionnaire_instances_list.html',
    bindings: {
      questionnaireInstances: '<',
      title: '<'
    }
  },
  deps: []
};